.format {
  background-size: contain;
  height: 18px;
  width: 18px;
  margin-top: 2px;
  opacity: 0.6;
}

button:disabled .format {
  opacity: 0.2;
}

.undo {
  background-image: url("../images/arrow-counterclockwise.svg");
}

.redo {
  background-image: url("../images/arrow-clockwise.svg");
}
